__turbopack_context__.v({
  "actions": "sidebar-module__7wc3yG__actions",
  "badge": "sidebar-module__7wc3yG__badge",
  "counter": "sidebar-module__7wc3yG__counter",
  "disabled": "sidebar-module__7wc3yG__disabled",
  "filter": "sidebar-module__7wc3yG__filter",
  "groupTitle": "sidebar-module__7wc3yG__groupTitle",
  "header": "sidebar-module__7wc3yG__header",
  "itemText": "sidebar-module__7wc3yG__itemText",
  "list": "sidebar-module__7wc3yG__list",
  "loading": "sidebar-module__7wc3yG__loading",
  "row": "sidebar-module__7wc3yG__row",
  "rowButton": "sidebar-module__7wc3yG__rowButton",
  "scrollArea": "sidebar-module__7wc3yG__scrollArea",
  "secondary": "sidebar-module__7wc3yG__secondary",
  "withBadge": "sidebar-module__7wc3yG__withBadge",
  "wrapper": "sidebar-module__7wc3yG__wrapper",
});
